import { type BackendSessionPayload } from '../../../backend_schemas'
import { emitEvent, EventListenerList } from '../../../lib/event/event'
import ls from '../../../lib/localStorage'
import { Nullable } from '../../../typescript'
import { VITE_BACKEND_JWT_LS_KEY } from './auth_session_key'
import getBackendSessionPayloadFromLocalStorage from './getAuthSessionFromLocalStorage'

export const sessionValueUpdatedEvent: EventListenerList<Nullable<BackendSessionPayload>> = [(newValue) => {
  ls.setItem(VITE_BACKEND_JWT_LS_KEY, JSON.stringify(newValue))
}]

let sessionValue: Nullable<BackendSessionPayload> = getBackendSessionPayloadFromLocalStorage()

export function getSessionValue(): Nullable<BackendSessionPayload> {
  return sessionValue
}

export function updateSessionValue(newValue: Nullable<BackendSessionPayload>): void {
  sessionValue = newValue
  emitEvent(sessionValueUpdatedEvent, newValue)
}

window.addEventListener('storage', function (event) {
  if (event.key === VITE_BACKEND_JWT_LS_KEY) {
    const newValue: Nullable<BackendSessionPayload> = event.newValue ? JSON.parse(event.newValue) : null
    updateSessionValue(newValue)
  }
})
